/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteCureCtrl',["$log","$scope","$anchorScroll","$rootScope","$routeParams","$location","CureData","$timeout",
        function($log,$scope,$anchorScroll,$rootScope,$routeParams,$location,CureData,$timeout)
        {
            $scope.currentCureId =  parseInt($routeParams.cureId);
            $scope.redirectToHomeWhenAccessIsNotGranted();
            $scope.$watch('ad.dataLoaded', function(newValue, oldValue)
            {
                if (newValue)// && !$scope.ad.view.currentCureView)
                {
                    var cure = CureData.getById( $scope.currentCureId);
                    if (cure)
                    {
                        $scope.ad.msgErrorCure = "";
                        $scope.setCurrentCureView($scope.ad.view.cureCategoryRootView.getCureView(cure),false);
                    }
                    else
                    {
                        $scope.ad.msgErrorCure = "Nous sommes désolés mais cette cure n'existe plus ou ne peut plus être achetée.";
                    }
                    $timeout(function() {
                        if(window.FB) {
                            window.FB.XFBML.parse();
                        }
                    },200);
                }
            });

        }
    ]);


// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteCureCtrl.js